(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // node_modules/loadx/dist/loadx.module.js
  var n = function() {
    var n2 = {};
    function r(r2, t, e) {
      return new Promise(function(o, u) {
        if (t === null || !(t instanceof HTMLElement))
          return u(new Error("Parent not found."));
        var c = function(r3) {
          var t2 = JSON.stringify(r3), e2 = n2[t2];
          return e2 !== void 0 ? e2 : null;
        }(e);
        if (c !== null)
          return o(c);
        var i = document.createElement(r2);
        i.onload = function() {
          o(i), function(r3, t2) {
            var e2 = JSON.stringify(r3);
            n2[e2] = t2;
          }(e, i);
        }, i.onerror = function(n3) {
          u(new URIError("The asset " + n3.target.src + " didn't load correctly."));
        }, Object.keys(e).forEach(function(n3) {
          i[n3] = e[n3];
        }), t.appendChild(i);
      });
    }
    return r.js = function(n3) {
      return r("script", document.body, { src: n3 });
    }, r.css = function(n3) {
      return r("link", document.head, { type: "text/css", rel: "stylesheet", href: n3 });
    }, r.img = function(n3, t) {
      return r("img", function(n4) {
        return n4 === void 0 ? document.body : n4;
      }(t), { src: n3 });
    }, r;
  }();
  var loadx_module_default = n;

  // src/js/components/media.js
  var _Media = class {
    static async init() {
      const medias = window.Store.theContainer.querySelectorAll(_Media.params.selectors.el);
      const galleries = window.Store.theContainer.querySelectorAll(_Media.params.selectors.gallery);
      if (!medias.length && !galleries.length)
        return null;
      if (!window.Store.components.media.lib_loaded) {
        await loadx_module_default.css("https://unpkg.com/glightbox@3.2.0/dist/css/glightbox.min.css");
        await loadx_module_default.js("https://unpkg.com/glightbox@3.2.0/dist/js/glightbox.min.js");
        window.Store.components.media.lib_loaded = true;
      }
    }
    static create() {
      const medias = window.Store.theContainer.querySelectorAll(_Media.params.selectors.el) ?? [];
      const galleries = window.Store.theContainer.querySelectorAll(_Media.params.selectors.gallery) ?? [];
      let objects = [];
      medias.forEach((media) => {
        const obj = new _Media([media]);
        obj.setListeners();
        objects.push(obj);
      });
      galleries.forEach((gallery) => {
        const items = gallery.querySelectorAll(_Media.params.selectors.galleryItem);
        const obj = new _Media(items);
        obj.setListeners();
        objects.push(obj);
      });
      return objects;
    }
    constructor(element) {
      this.elements = element;
      this.obj = GLightbox({
        touchNavigation: element.length > 1,
        keyboardNavigation: element.length > 1,
        autoplayVideos: true,
        openEffect: "custom",
        closeEffect: "custom",
        cssEfects: {
          custom: { in: "enter", out: "leave" }
        },
        elements: [...element],
        plyr: {
          config: {
            ratio: "16:9",
            muted: false,
            hideControls: true,
            controls: ["play", "progress", "current-time", "mute", "captions", "pip", "airplay"],
            youtube: {
              noCookie: true,
              rel: 0,
              showinfo: 0,
              iv_load_policy: 3
            }
          }
        }
      });
    }
    setListeners(e) {
      this.elements.forEach((e2) => {
        e2.addEventListener("click", this.open.bind(this));
      });
      this.obj.on("open", () => {
        window.Store.theBody.classList.add(_Media.params.modifiers.body_active);
      });
      this.obj.on("close", () => {
        window.Store.theBody.classList.remove(_Media.params.modifiers.body_active);
      });
    }
    open(e) {
      e.preventDefault();
      this.obj.open();
    }
  };
  var Media = _Media;
  __publicField(Media, "params", {
    selectors: {
      el: ".js-media",
      gallery: ".js-media-gallery",
      galleryItem: ".js-media-gallery-item"
    },
    modifiers: {
      body_active: "is-media-playing"
    }
  });
  window.Store.components.media.render = () => {
    Media.init().then(() => {
      window.Store.components.media.obj = Media.create();
    });
  };
})();
